/**
 * "View Latest Version" / Keep-or-Revert save-conflict flow (see the
 * purring-humming-mountain plan). Same JSON.stringify(window.guide_obj)/
 * decodeGuideFb pattern readGuideDataReturnNew (HomeHeader.js) already uses
 * for a normal load — just sessionStorage instead of Firestore, and plain
 * functions (not component methods) so the globally-mounted
 * ConflictPreviewBanner can call them regardless of which screen originally
 * showed the conflict dialog. Dispatches straight through the raw `store`
 * singleton rather than a passed-in `dispatch` — these aren't React hooks,
 * so there's no component context to get one from.
 */
import store from "../store/store";
import { slice1Actions } from "../store/reducer";
import Guide from "../Models/Guide";

// Single fixed key: only one guide is ever active at a time, so nothing is
// lost by overwriting it on reuse (matches andiamo_comment_dismiss_v1 /
// andiamo_no_good_photo_v1's naming convention).
export const CONFLICT_SNAPSHOT_KEY = "andiamo_guide_conflict_snapshot_v1";

// Called by "View Latest Version"'s handler BEFORE it loads the server's
// latest guide over window.guide_obj.
export function stashConflictSnapshot(guide_id) {
  try {
    sessionStorage.setItem(
      CONFLICT_SNAPSHOT_KEY,
      JSON.stringify({
        guide_id,
        guide_json: JSON.stringify(window.guide_obj),
        guide_attributes: window.guide_obj.attributes,
      })
    );
  } catch (e) {
    console.log("stashConflictSnapshot error", e.message);
  }
}

// "Keep this version" — the latest content is already window.guide_obj
// (loaded when "View Latest Version" was clicked), so there's nothing to
// restore, just clear the stash and the banner.
export function keepConflictPreview() {
  try {
    sessionStorage.removeItem(CONFLICT_SNAPSHOT_KEY);
  } catch (e) {
    console.log("keepConflictPreview error", e.message);
  }
  store.dispatch(slice1Actions.setPreviewingConflictSnapshot({ value: false }));
}

// "Revert to my copy" — decode the stashed snapshot exactly like a normal
// guide load and make it window.guide_obj again, discarding whatever was
// done while previewing the latest version.
export function revertConflictSnapshot() {
  try {
    const raw = sessionStorage.getItem(CONFLICT_SNAPSHOT_KEY);
    if (raw) {
      const { guide_id, guide_json, guide_attributes } = JSON.parse(raw);
      const guide_obj_json = JSON.parse(guide_json);
      const GuideObj = new Guide(guide_id);
      const decoded = GuideObj.decodeGuideFb(guide_obj_json, guide_attributes);
      if (decoded === true) {
        GuideObj.schedule.getPlaces_InSchedule();
        window.guide_obj = GuideObj;
        store.dispatch(slice1Actions.setGuide({ guide: "new" }));
      }
    }
  } catch (e) {
    console.log("revertConflictSnapshot error", e.message);
  }
  try {
    sessionStorage.removeItem(CONFLICT_SNAPSHOT_KEY);
  } catch (e) {
    console.log("revertConflictSnapshot cleanup error", e.message);
  }
  store.dispatch(slice1Actions.setPreviewingConflictSnapshot({ value: false }));
}
